import { ColorRange } from '../../../../common/colorRange';
import { Component, OnInit } from '@angular/core';
import { ManagedLinkKey } from 'src/common/managedLinkKey';
import { AppState } from 'src/app/reducers';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { collapseAnimation } from '../access.animations';
import { AccesoAplicacionFav } from 'src/common/acceso';
import { AllAplicacionRequested, AplicacionFavInit } from '../../home/store/aplicacion/aplicacion.actions';
import { AplicacionesFavsToggleRequested } from '../../home/store/acceso/acceso.actions';
import { aplicacionesFavsCollapsed } from '../../home/store/acceso/acceso.selectors';
import { aplicacionFavoritas } from '../../home/store/aplicacion/aplicacion.selectors';

@Component({
	selector: 'main-app',
	templateUrl: './main-app.component.html',
	styleUrls: ['./main-app.component.scss'],
	animations: [ collapseAnimation ]
})
export class MainAppComponent implements OnInit {

	readonly STORED_LINK: ManagedLinkKey = ManagedLinkKey.STORED_LINK;
	readonly ICON_SIZE: string = "1.8";
	readonly ICON_TEXT_SIZE: string = "1";
	readonly OBJECT_KEYS = Object.keys;
	macceso$: Observable<AccesoAplicacionFav[]>;
	isCollapsed$: Observable<boolean>;
	colors: Object = {};	// key: nombre aplicación, value: color

	constructor( private store: Store<AppState>, private colorRange: ColorRange ) {
	}

	ngOnInit(): void {
		this.store.dispatch( new AllAplicacionRequested( { forceReload: false } ) );

		this.store.dispatch( new AplicacionFavInit() );

		this.isCollapsed$ = this.store.select( aplicacionesFavsCollapsed );

		this.macceso$ = this.store.select( aplicacionFavoritas )
			.pipe(
				tap( (accesos: AccesoAplicacionFav[]) => {
					if( accesos && accesos.length > 0 ) {
						let keys: string[] = accesos.map( acceso => acceso.nombre );
						this.colors = this.colorRange.assignColors( keys );
					}
				})
			);
	}

	refresh(): void {
		this.store.dispatch( new AllAplicacionRequested( { forceReload: true } ) );
	}

	toggleCollapse( event: Event ) {
		this.store.dispatch( new AplicacionesFavsToggleRequested() );
		event.stopPropagation();
	}

	onManyPerfilesSelected( event: Event ) {
		event.stopPropagation();
	}

}
